import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ODataBaseBinding } from '@app/shared/odata-base-binding.service';
import { Environment } from '@env/environment';
import { Observable } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { SortDescriptor, State } from '@progress/kendo-data-query';
import { map } from 'rxjs/operators';
import { ODataSettings } from '@progress/kendo-data-query/dist/npm/odata.operators';

@Injectable({ providedIn: 'root' })
export class SdsSearchOdataService extends ODataBaseBinding {
	constructor(http: HttpClient, environment: Environment) {
		super(http, environment.services['employee'], 'SdsList');
	}
	public fetch(resourceName: string, state: State, settings?: ODataSettings): Observable<GridDataResult> {
		return super.fetch(resourceName, state, settings).pipe(
			map((response) => {
				return response;
			})
		);
	}

	// fetchCount() {
	// 	const queryString = `$count=true&$top=0`;
	// 	let buildUrl: string = encodeURI(`${this.baseUrl}Tasks?${queryString}`);

	// 	return this.http.get(buildUrl).pipe(
	// 		map((response) => {
	// 			return {
	// 				total: parseInt(response['@odata.count']),
	// 			};
	// 		})
	// 	);
	// }
}
